// Default rendering configuration for the lamp builder
export const defaultRenderingConfig = {
  material: {
    color: "#ffffff",
    roughness: 1.546,
    metalness: 0,
    bumpScale: 0.04,
    opacity: 0.95,
    emissiveColor: "#fbffa8",
    emissiveIntensity: 0.314
  },
  lighting: {
    ambientIntensity: 0,
    directionalIntensity: 3.978,
    pointLightIntensity: 0,
    directionalPosition: {
      x: 10,
      y: 10,
      z: 5
    },
    pointLight1Position: {
      x: -5,
      y: 5,
      z: -5
    },
    pointLight2Position: {
      x: 5,
      y: -5,
      z: 5
    },
    ambientColor: "#ffffff",
    directionalColor: "#ffffff",
    pointLightColor: "#ffffff"
  },
  shadows: {
    enabled: true,
    mapSize: 2048,
    shadowBias: -0.002
  },
  overhang: {
    enabled: true,
    opacity: 0.46,
    threshold: 60,
    color: "#FF4500"
  },
  clash: {
    enabled: true,
    opacity: 0.5,
    color: "#00BFFF"
  },
  printableArea: {
    enabled: true,
    opacity: 0.5,
    color: "#32CD32"
  },
  background: {
    color: "#292929"
  },
  view: {
    wireframe: true,
    showVertices: false,
    wireframeColor: 0,
    wireframeThickness: 1
  }
};

// extends and overrides default rending config
export const thumbnailRenderingConfig = {
  background: {
    color: "#f5f5f5"
  }
}; 
